import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { Button } from "./ui/button";
import { Checkbox } from "./ui/checkbox";
import { Textarea } from "./ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";

export function PublishDialog({ open, onOpenChange, company, items = [], onDone }) {
  const [sel, setSel] = useState(new Set());
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) { setSel(new Set(items.map((i) => i.id))); setMsg(""); } }, [open]); // eslint-disable-line
  const toggle = (id) => { const n = new Set(sel); n.has(id) ? n.delete(id) : n.add(id); setSel(n); };
  const go = async () => {
    setBusy(true);
    try { await api.post("/requests/publish", { ids: [...sel], message: msg }); toast.success(`${sel.size} resultado(s) enviado(s) ao cliente`); onOpenChange(false); onDone?.(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="publish-dialog">
        <DialogHeader><DialogTitle>Enviar resultados</DialogTitle><DialogDescription>{company} · {items.length} demanda(s) concluída(s) aguardando envio</DialogDescription></DialogHeader>
        <div className="divide-y border rounded-lg max-h-72 overflow-y-auto">{items.map((i) => (
          <label key={i.id} className="flex items-start gap-3 px-3 py-2.5 cursor-pointer hover:bg-slate-50" data-testid={`publish-item-${i.id}`}>
            <Checkbox className="mt-0.5" checked={sel.has(i.id)} onCheckedChange={() => toggle(i.id)} data-testid={`publish-check-${i.id}`} />
            <span className="min-w-0"><span className="block text-sm font-medium">{i.label} — {i.employee_name || i.title}</span><span className="block text-[11px] text-slate-500 font-mono">#{i.protocol}</span></span></label>))}</div>
        <Textarea rows={3} value={msg} onChange={(e) => setMsg(e.target.value)} placeholder="Mensagem geral opcional (ex.: Concluímos as solicitações abaixo.)" data-testid="publish-message" />
        <DialogFooter><Button variant="outline" onClick={() => onOpenChange(false)}>Voltar</Button>
          <Button disabled={busy || !sel.size} onClick={go} className="font-bold" data-testid="publish-submit"><Send className="h-4 w-4 mr-1.5" />ENVIAR {sel.size} RESULTADO{sel.size === 1 ? "" : "S"}</Button></DialogFooter>
      </DialogContent>
    </Dialog>);
}
